// original: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/a3074a0a75dfbdb23ad52e6a2e9a41799014b3b1/static/js/team/operators/teamTreeToOptions.ts

import { toOptionWithDepth } from './toOptionWithDepth';
const nodeToOption = (node, depth, isUngatedForHelpDeskRoutingScopeFiltering) => {
  return toOptionWithDepth(node.get('data'), depth, isUngatedForHelpDeskRoutingScopeFiltering);
};
const traverse = (node, list, depth, isUngatedForHelpDeskRoutingScopeFiltering) => {
  list.push(nodeToOption(node, depth, isUngatedForHelpDeskRoutingScopeFiltering));
  node.get('childTeams').forEach(childTeam => {
    traverse(childTeam, list, depth + 1, isUngatedForHelpDeskRoutingScopeFiltering);
  });
  return list;
};
export const teamTreeToOptions = (teamTree, isUngatedForHelpDeskRoutingScopeFiltering) => {
  const list = [];
  teamTree.forEach(node => {
    traverse(node, list, 1, isUngatedForHelpDeskRoutingScopeFiltering);
  });
  return list;
};